// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__dhonY","footerInner":"style_footerInner__2zyVu","logo":"style_logo__2bLgC"};